module.exports = __webpack_public_path__ + "static/media/apicafe-logo.3f35653e.svg";